import { useNavigate, useParams } from "react-router-dom";
import Typography from "../../../../../components/Typography/Typography";
import Form from "../../../../../components/forms/Form";
import Button from "../../../../../components/Button/Button";
import { sustainabilityValidationSchema } from "../../../../../utils/validationUtils";
import BasicInformation from "./sections/BasicInformation";
import SustainabilityInfoSection from "./sections/SustainabilityInfoSection";
import ProjectSection from "./sections/ProjectSection";
import ProfitDedicationSection from "./sections/ProfitDedication";

export default function SustainabilityConfiguration({
    handleSubmit,
    initialValues,
    isLoading = false,
    sustainabilityBannerImage,
    handleSustainabilityBannerSelected,
    profitSectionTopImage,
    profitSectionBottomImage,
    handleProfitSectionTopImageSelected,
    handleProfitSectionBottomImageSelected,
}) {
    // Navigation hooks
    const navigate = useNavigate();
    const { id } = useParams();

    // Navigation handler
    const handleCancelClick = () => {
        navigate(`/overview/${id}/site-builder`);
    };

    return (
        <div className="container-fluid px-0">
            <Typography variant="h3" className="mb-3">
                Sustainability Configuration
            </Typography>

            <Form
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={sustainabilityValidationSchema}
                enableReinitialize={true}
            >
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <BasicInformation
                                    initialValues={initialValues}
                                    bannerImage={sustainabilityBannerImage}
                                    handleBannerFileSelected={
                                        handleSustainabilityBannerSelected
                                    }
                                />
                                <ProfitDedicationSection
                                    initialValues={initialValues}
                                    topImage={profitSectionTopImage}
                                    handleTopImageSelected={
                                        handleProfitSectionTopImageSelected
                                    }
                                />
                                <ProjectSection
                                    initialValues={initialValues}
                                    bottomImage={profitSectionBottomImage}
                                    handleBottomImageSelected={
                                        handleProfitSectionBottomImageSelected
                                    }
                                />
                                <SustainabilityInfoSection />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Action buttons */}
                <div className="row mt-4">
                    <div className="col-12 d-flex justify-content-between align-items-center gap-3">
                        <div>
                            <Button
                                type="button"
                                variant="secondary"
                                onClick={handleCancelClick}
                            >
                                Cancel
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="submit"
                                className="float-end"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <div>
                                        <span
                                            className="spinner-border spinner-border-sm mx-2"
                                            aria-hidden="true"
                                        ></span>
                                        <span role="status">Saving...</span>
                                    </div>
                                ) : (
                                    "Save Configuration"
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    );
}
